module.exports = __webpack_public_path__ + "img/Filter.f4179ba0.svg";